import apiClient from "../api";

const configApi = {
  getConfigs: () => apiClient.get("/get-values"),
};

export default configApi;
